import classes from './FalseInputSearch.module.css'

const FalseInputSearch = ({minWidth, label, value, action, isLoading}) => {

    const clickhandler = () => {
        if (action) {
            action()
        }
    }

    return <div className={`${classes.container} ${!value ? classes.empty_input : ''}`} style={{minWidth: minWidth}} onClick={clickhandler} title={value}>
        <div className={classes.container_inner}>
            {label && <div className={classes.label}>{label}</div>}
            {value && <div className={classes.input}>{value}</div>}
        </div>
        {isLoading && <div className={classes.loader_container}>
            <span className="loader-circle"></span>    
        </div>}
    </div>
}

export default FalseInputSearch